export default "__VITE_ASSET__a680864a__"